import { Vec2 } from "./Vec2";

export interface BoundingBox {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export function boundingBoxCenter(boundingBox: BoundingBox): Vec2 {
  return {
    x: Math.floor((boundingBox.left + boundingBox.right) / 2),
    y: Math.floor((boundingBox.top + boundingBox.bottom) / 2)
  };
}

export function boundingBoxWidth(boundingBox: BoundingBox): number {
  return boundingBox.right - boundingBox.left;
}

export function boundingBoxHeight(boundingBox: BoundingBox): number {
  return boundingBox.bottom - boundingBox.top;
}

export function boundingBoxUnion(a: BoundingBox, b: BoundingBox): BoundingBox {
  return {
    left: Math.min(a.left, b.left),
    top: Math.min(a.top, b.top),
    right: Math.max(a.right, b.right),
    bottom: Math.max(a.bottom, b.bottom)
  };
}

export function boundingBoxOffset(boundingBox: BoundingBox, offset: Vec2): BoundingBox {
  return {
    left: boundingBox.left + offset.x,
    top: boundingBox.top + offset.y,
    right: boundingBox.right + offset.x,
    bottom: boundingBox.bottom + offset.y
  };
}
